<script setup lang="ts">
const props = defineProps({
  title: {
    type: String as PropType<string>,
    default: '',
  },
  description: {
    type: String as PropType<string>,
    default: '',
  },
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<template>
  <div
    :class="[
      'bg-white lg:overflow-hidden feature-container relative',
      'xs:px-4 sm:px-6 lg:px-12 xs:py-8 lg:py-18 feature-container-primary',
    ]"
  >
    <section class="mx-auto max-w-6.5xl feature-section relative">
      <SectionHeader v-if="title || description" :title="title" :subtitle="description" class='mb-10' :type="'feature'" />
			<CustomersReviewItem  v-for="({ title, description, items, avatar, avatar_text, avatar_job, imageName, bgName, colorClasses, id }, index) in items" :key="id" :title="title" :description="description" :items="items" :image-name="imageName" :bg-name="bgName" :color-classes="colorClasses" :type="'secondary'" :reverse="(index % 2) !== 1" :avatar="avatar" :avatar-text="avatar_text" :avatar-job="avatar_job" :id="id" />
    </section>
  </div>
</template>

<style lang="scss" scoped></style>
